import styles from "./congrats.module.scss";
import { CongratsProps, IStatus } from "../../types";
import IMAGE from "../../config/imgConfig";
import BottomCards from "../../components/BottomCards/BottomCards";
import { useTranslations } from "../../contexts/LanguageContext";
import { Button } from "cdhs-ui-library";
import { useAppSelector } from "../../store/store";
import { useState } from "react";
import { ErrorSuccessMessage } from "../../components/ErrorSuccessMessage/ErrorSuccessMessage";

function Congratulations({ SurveyType = "baseline", incentive, age }: CongratsProps) {
  const t = useTranslations();
  const docusign = useAppSelector((state)=> state.survey.docusignUri)
  const [userFeedback, setUserFeedback] = useState<IStatus>({error: undefined, success: undefined, loading: false})
   const [disableW9Button, setDisableW9Button] = useState<boolean>(false);
 const w9Url = docusign 
 console.log("DOCUSIGN URI", w9Url)
 function handleW9(){
    setUserFeedback({success: undefined, error: undefined})
    setDisableW9Button(true)
   if (w9Url) {
     window.open(w9Url, "__blank")
    setUserFeedback({success: t("congratsPage_w9SuccessMessage", "A W9 form opened in a new window. Please fill it out to receive your incentive. If you need to make edits afterwards or experience issues please contact cdhs_trails_nytd@state.co.us "), error: undefined})
  }else {
    setUserFeedback({error: t("congratsPage_w9ErrorMessage", "There was an error requesting your W9. Please go to your profile to request it again so you can receive your incentive"), success: undefined})
  }
  }
  return (
    <section className={styles.mainContainer}>
      <header className={styles.header}>
        <img src={IMAGE.CONGRATS_CONFETTI_DESKTOP.url} alt={t('alt_congratsConfetti', IMAGE.CONGRATS_CONFETTI_DESKTOP.alt)}  className={styles.desktopImg} />
        <img src={IMAGE.CONGRATS_CONFETTI_MOBILE.url} alt={t('alt_congratsConfetti', IMAGE.CONGRATS_CONFETTI_DESKTOP.alt)}  className={styles.mobileImg} />
      </header>
      <div className={styles.mainContent}>
        <h1 id="congrats-heading">{t('congratsPage_mainTitle', 'Congratulations!')}</h1>
        <p>{t('congratsPage_completedSurveyPart1', 'You have successfully completed the NYTD')}
          {SurveyType && ` ${SurveyType} `} 
          {t('congratsPage_completedSurveyPart2', 'survey.')} </p>
        <p>
          {t('congratsPage_incentiveMessagePart1', 'You have just completed the ')}
             {age} 
          {t('congratsPage_incentiveMessagePart2', ' year old ')}
             {SurveyType}
          {t('congratsPage_incentiveMessagePart3', ' NYTD survey. Youth who are part of this survey group who complete a survey will receive ')}
          {incentive}.
        </p>
        <ErrorSuccessMessage error={userFeedback.error} success={userFeedback.success} loading={userFeedback.loading}/>
                
        <p><strong>{t('congratsPage_slogan', 'Remember: Your Answers Make A Difference!')}</strong></p>
        <h2 id="next-steps-heading">{t('congratsPage_nextStepsTitle', 'Next Steps')}</h2>
        <p>
          {t('congratsPage_nextStepsParagraph', 'Please complete a W9 and provide your most current email address as the incentive may arrive as a check or as an electronic gift card.')}
        </p>

        <Button caption="Fill out W9 Form" variant="NYTD" onClick={()=>handleW9()} disabled={disableW9Button}/>
      </div>
    <BottomCards /> 
    </section>
  );
}

export default Congratulations;
